module.exports = __webpack_public_path__ + "img/gn.86f8ec9f.svg";